<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a v-if="!localId" class=" section" v-on:click="goTo('/local/parcels')">Paquetes</a>
    <a v-if="localId" class=" section" v-on:click="goTo('/local/' + localId + '/parcels')">Paquetes</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Información</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Datos del envío</div>
  </h1>

  <button v-if="parcelInfo && parcelInfo.LocalShipment.status =='new' && !parcelInfo.LocalShipment.canceled" id="idBtnAnular" class="ui red button rightButton" v-on:click="cancelParcel(id)">
    <i class="close icon"></i>Cancelar envío
  </button>

  <div v-if="!parcelInfo" class="ui active centered inline loader"></div>
  <div v-if="parcelInfo" class="ui stackable three column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Comercio</h4>
        <div class="form ui">
          <div class="field">
            <label>Nombre</label>
            <input type="text" v-model="parcelInfo.LocalUser.name" readonly>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="parcelInfo.LocalUser.phone" readonly>
          </div>
          <div class="field">
            <label>Email</label>
            <input type="text" v-model="parcelInfo.LocalUser.email" readonly>
          </div>
          <div class="field">
            <label>Código de entrega</label>
            <input type="text" v-model="parcelInfo.LocalShipment.dropoff_code" readonly>
          </div>
        </div>
      </div>
      <div class="column">
        <h4 class="ui dividing header">Cliente</h4>
        <div class="form ui">
          <div class="field">
            <label>Nombre</label>
            <input type="text" v-model="parcelInfo.LocalShipment.name" readonly>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="parcelInfo.LocalShipment.phone" readonly>
          </div>
          <div class="field">
            <label>Email</label>
            <input type="text" v-model="parcelInfo.LocalShipment.email" readonly>
          </div>
          <div class="field">
            <label>Código de recogida</label>
            <input type="text" v-model="parcelInfo.LocalShipment.open_code" readonly>
          </div>
        </div>
      </div>
      <div class="column">
        <h4 class="ui dividing header">Envío</h4>
        <div class="form ui">
          <div class="field">
            <label>Locker</label>
            <input type="text" v-model="parcelInfo.Apt.LanguagesApts[0].name" readonly>
          </div>
          <div class="field">
            <label>Tamaño</label>
            <input type="text" v-model="parcelInfo.LocalShipment.slot_size" readonly>
          </div>
          <div class="field">
            <label>Estado</label>
            <input type="text" v-model="parcelInfo.LocalShipment.status" readonly>
          </div>
          <div class="field">
            <label>Última actualización</label>
            <input type="text" v-model="parcelInfo.LocalShipment.modified" readonly>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="parcelInfo" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Notificaciones al usuario</h4>
        <div class="ui relaxed divided list">
          <div class="item" v-for="sms in parcelInfo.smslist" :key="sms.id">
            <img class="ui mini image" src="../../assets/in-apt.png">
            <div class="content">
              <span class="header">{{sms.SmsStatus.created}}</span>
              <div class="description"><b>{{sms.SmsStatus.from_name}}:</b> <span class="txiki">{{sms.SmsStatus.text}}</span></div>
            </div>
            <div class="right floated content">
              <span class="header">{{sms.SmsStatus.to_phone}}</span>
              <div class="description">{{sms.SmsStatus.status}}</div>
            </div>
          </div>
        </div>
        <div v-if="parcelInfo.LocalShipment.status=='in-apt'" class="ui button green" v-on:click="resendSms(parcelInfo.LocalShipment.parcel_id,parcelInfo.LocalShipment.phone)">Re-enviar</div>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
//barcode
import VueBarcode from 'vue-barcode';
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'localParcelInfo',
  props: ['id','localId'],
  data() {
    return {
      parcelInfo: null
    }
  },
  created() {
    this.getParcelInfo();
  },
  methods: {
    getParcelInfo() {
      hapiickApi().post('/v3/locals/shipments/get-local-shipment', {
        admin_id: JSON.parse(localStorage.admin).id,
        id: this.id,
        localId: this.localId
      })
      .then(request => this.setParcelInfo(request))
      .catch((request) => console.log('error getting parcels: ' + request))
    },
    setParcelInfo(req) {
      this.parcelInfo = JSON.parse(JSON.stringify(req.data.parcel))
    },
    resendSms(id, phone) {
      let provider_id = this.parcelInfo.smslist[0].SmsStatus.provider_id
      hapiickApi().post('/v3/shipments/sms/resend', {
        admin_id: JSON.parse(localStorage.admin).id,
        parcel_id: id,
        provider_id: provider_id,
        phone: phone,
        from: this.parcelInfo.LocalShipment.user,
        apt_id: this.parcelInfo.Apt.id,
      })
      .then(request => this.getParcelInfo())
      .catch((request) => console.log('error getting parcels: ' + request))
    },
    cancelParcel (id) {
      let x = document.getElementById("idBtnAnular");
      x.classList.add("loading");
      x.disabled = true;

      this.$swal({
        title: '¿Estas seguro que quieres cancelar el envío?',
        text: 'Los envíos cancelados se eliminaran.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          hapiickApi().post('/v1/locals/shipments/cancel', {
            admin_id: JSON.parse(localStorage.admin).id,
            local_shipment_id: this.id
          })
          .then(request => {
            if (request.data.result) {
              this.goTo('/local/parcels', 'localParcels')
            } else {
              this.$swal({
                type: 'info',
                text: 'No se ha podido cancelar el envío.',
              })
            }
          })
          .catch((request) => console.log('error cancel parcel: ' + request))
        } else {
          x.classList.remove("loading");
          x.disabled = false;
        }
      })
    },
    goTo(where) {
      this.$router.push(where)
    },
  },
  components: {
    'barcode': VueBarcode
  }
}
</script>

<style scoped>
.txiki {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Local/localParcelInfo.vue